/* eslint-disable react/prop-types */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@telus-uds/components-web';
import {
  customerAuthorized,
  customerAuthorizedValcan
} from '../../utils/constant';
import { CheckboxFieldWrapper } from './css';
import Note from '../../note';

const FieldCheckbox = ({ data }) => {
  const {
    ref,
    checked,
    name,
    label,
    value,
    onChange,
    note,
    isShowNoteBackground,
    isNoteCheckBox,
    readonly,
    // eslint-disable-next-line no-unused-vars
    mainLabel,
    longLabel = '',
    formFields
  } = data;

  const lastForwardedRef = useRef(null);
  const lastForwardedTimeRef = useRef(0);

  const LabelLogic =
    formFields && formFields.telusOptikTvComments
      ? label.split('($')[0]
      : label;
  /**
   * for fields whose label value does not fit in 'label' due to max 255 character limit
   */
  const labelValue = longLabel !== '' ? longLabel : LabelLogic;
  const convertBoolValueToString =
    name === customerAuthorized || name === customerAuthorizedValcan;

  const labelMain = isNoteCheckBox
    ? (note && note.content && (
        <Note
          type="richText"
          data={note}
          isShowNoteBackground={isShowNoteBackground}
        />
      ))
    : labelValue;

  const isLabelString = typeof labelMain === 'string';
  const isChecked = Boolean(checked);

  const handleCheckboxChange = (newChecked) => {
    if (!onChange) return;

    const now = Date.now();
    const lastVal = lastForwardedRef.current;
    const lastTime = lastForwardedTimeRef.current;
    if (
      lastVal != null &&
      newChecked !== lastVal &&
      now - lastTime < 80
    ) {
      return;
    }
    lastForwardedRef.current = newChecked;
    lastForwardedTimeRef.current = now;

    let valueForTarget;
    if (convertBoolValueToString) {
      valueForTarget = newChecked ? value : '';
    } else {
      valueForTarget = newChecked;
    }
    const syntheticEvent = {
      target: {
        name,
        value: valueForTarget,
        checked: newChecked
      }
    };
    onChange(syntheticEvent);
  };

  return (
    <>
      <CheckboxFieldWrapper>
        {/* {mainLabel && <p className="frg-body-font-14px">{mainLabel}</p>} */}
        {convertBoolValueToString ? (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <input
              ref={ref}
              style={{
                marginRight: '1rem',
                height: '1.25rem',
                width: '1.25rem',
                borderRadius: '4px'
              }}
              type="checkbox"
              value={value || ''}
              id={name}
              name={name}
              checked={isChecked}
              onChange={onChange}
              disabled={readonly}
            />
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label style={{ color: 'red', cursor: 'pointer' }} htmlFor={name}>
              {label}
            </label>
          </div>
        ) : (
          <>
            {isNoteCheckBox && labelMain}
            <Checkbox
              ref={ref}
              id={name}
              name={name}
              value={value || ''}
              label={isLabelString ? labelMain : ''}
              checked={isChecked}
              onChange={handleCheckboxChange}
              inactive={readonly}
            />
          </>
        )}
      </CheckboxFieldWrapper>
    </>
  );
};

FieldCheckbox.propTypes = {
  data: PropTypes.shape({
    ref: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.node })]),
    checked: PropTypes.bool,
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    mainLabel: PropTypes.string,
    formFields: PropTypes.shape({}),
    label: PropTypes.string,
    value: PropTypes.string,
    readonly: PropTypes.bool,
    longLabel: PropTypes.string,
    onChange: PropTypes.func.isRequired
  }).isRequired
};

export default FieldCheckbox;
